import React from 'react';
import { Box, keyframes } from '@mui/material';

const knightRiderSweep = keyframes`
  0% {
    left: 0%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 0%;
  }
`;

interface KnightRiderLoaderProps {
  color?: string;
  height?: number;
  width?: string;
}

export const KnightRiderLoader: React.FC<KnightRiderLoaderProps> = ({
  color = '#F5A800', // Horwath Gold
  height = 4,
  width = '100%',
}) => {
  return (
    <Box
      sx={{
        width,
        height: `${height}px`,
        backgroundColor: 'rgba(245, 168, 0, 0.1)', // Light Horwath Gold background
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '2px',
      }}
    >
      {/* Sweeping light effect */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: '30%',
          background: `linear-gradient(90deg,
            transparent 0%,
            ${color}40 20%,
            ${color} 50%,
            ${color}40 80%,
            transparent 100%)`,
          boxShadow: `0 0 10px ${color}, 0 0 20px ${color}80`,
          animation: `${knightRiderSweep} 2s ease-in-out infinite`,
        }}
      />
    </Box>
  );
};
